/* ============================================================
   Follow Your Bump — teaser + 3-step signup flow
   Step 1: email  -> Klaviyo profile (general list if configured)
   Step 2: due date (required) -> profile due_date + FYB list
   Step 3: success -> unique code (minted) or fallback code
   Namespaced; does not touch KlaviyoSignup / klaviyo-submit.js.
   ============================================================ */
(function (w, d) {
  'use strict';

  var root = d.getElementById('fyb-root');
  if (!root) return;

  /* ---------- config (from snippet data attrs / theme settings) ---------- */
  var CFG = {
    siteId: root.dataset.siteId || 'T3r2Jy',
    generalList: root.dataset.generalList || '',
    fybList: root.dataset.fybList || '',
    fallbackCode: root.dataset.fallbackCode || 'BUMP10',
    mintEndpoint: root.dataset.mintEndpoint || '',
    redirect: root.dataset.redirect || '/collections/all',
    revision: '2025-10-15',
    minFillMs: 900
  };

  /* Week card data — extracted from the Follow Your Bump email set (wks 4-40).
     Names exactly as the email tracker cards write them. */
  var FRUIT = {
    4:['🌱','A Sesame Seed'],5:['🌾','A Grain of Rice'],6:['🫘','A Lentil'],
    7:['🫐','A Blueberry'],8:['🍓','A Raspberry'],9:['🍒','A Cherry'],
    10:['🫒','An Olive'],11:['🍇','A Plum'],12:['🍈','A Lime'],
    13:['🌱','A Snow Pea'],14:['🍑','A Peach'],15:['🍎','An Apple'],
    16:['🥑','An Avocado'],17:['🍐','A Pear'],18:['🫑','A Bell Pepper'],
    19:['🍅','A Tomato'],20:['🍌','A Banana'],21:['🥕','A Carrot'],
    22:['🎃','A Spaghetti Squash'],23:['🍊','A Grapefruit'],24:['🌽','Corn on the Cob'],
    25:['🥔','A Swede'],26:['🥬','An Iceberg Lettuce'],27:['🥦','A Cauliflower'],
    28:['🍆','An Aubergine'],29:['🎃','A Butternut Squash'],30:['🥬','A Cabbage'],
    31:['🥥','A Coconut'],32:['🥦','Broccoli'],33:['🍍','A Pineapple'],
    34:['🍈','A Cantaloupe Melon'],35:['🍈','A Honeydew Melon'],36:['🥬','A Romaine Lettuce'],
    37:['🌿','Swiss Chard'],38:['🥬','A Leek'],39:['🍉','A Watermelon'],
    40:['🎃','A Pumpkin']
  };

  var rx = /^[^\s@]+@[^\s@]{1,}\.[^\s@]{2,}$/i;
  var reduced = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var STATE_KEY = 'fyb_state';
  var QUEUE_KEY = 'fyb_queue';
  var EMAIL_KEY = 'fyb_email';
  function getState() { try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}'); } catch (e) { return {}; } }
  function setState(patch) {
    try {
      var s = getState();
      for (var k in patch) s[k] = patch[k];
      localStorage.setItem(STATE_KEY, JSON.stringify(s));
    } catch (e) {}
  }
  function getEmail() { try { return sessionStorage.getItem(EMAIL_KEY) || ''; } catch (e) { return ''; } }
  function setEmail(v) { try { sessionStorage.setItem(EMAIL_KEY, v); } catch (e) {} }
  /* dev/test convenience: ?fyb=reset clears all FYB state so the flow can be re-tested */
  try {
    if (/[?&]fyb=reset/.test(location.search)) {
      localStorage.removeItem(STATE_KEY); localStorage.removeItem(QUEUE_KEY); sessionStorage.removeItem(EMAIL_KEY);
    }
  } catch (e) {}
  var subscribed = getState().status === 'subscribed';

  /* Every stage of the flow is tracked here. The storefront gtag is Google Ads only, so GA4
     receives these through the "GA4 - Follow Your Bump" custom pixel (Settings > Customer events),
     which subscribes to each fyb_* name and forwards it with its params. */
  function track(ev, extra) {
    var o = { event: ev }; if (extra) for (var k in extra) o[k] = extra[k];
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(o); } catch (e) {}
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(ev, extra || {});
    } catch (e) {}
  }

  /* ---------- Klaviyo (client endpoints, public key only) ---------- */
  function kPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.siteId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': CFG.revision },
      body: JSON.stringify(body)
    });
  }
  function subscriptionPayload(email, listId, props) {
    var attrs = {
      email: String(email).trim(),
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (props) attrs.properties = props;
    var data = {
      type: 'subscription',
      attributes: { custom_source: 'Follow Your Bump', profile: { data: { type: 'profile', attributes: attrs } } }
    };
    if (listId) data.relationships = { list: { data: { type: 'list', id: listId } } };
    return { data: data };
  }
  function profilePayload(email, props) {
    return { data: { type: 'profile', attributes: { email: String(email).trim(), properties: props || {} } } };
  }
  function sendWithRetryQueue(path, body) {
    kPost(path, body).then(function (res) {
      if (!res.ok && res.status !== 409) queuePush(path, body);
    }).catch(function () { queuePush(path, body); });
  }
  function queuePush(path, body) {
    try {
      var q = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
      q.push({ p: path, b: body });
      localStorage.setItem(QUEUE_KEY, JSON.stringify(q.slice(-10)));
    } catch (e) {}
  }
  function queueFlush() {
    var q;
    try { q = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch (e) { q = []; }
    if (!q.length) return;
    try { localStorage.setItem(QUEUE_KEY, '[]'); } catch (e) {}
    q.forEach(function (item) { sendWithRetryQueue(item.p, item.b); });
  }

  /* ---------- elements ---------- */
  function $(sel) { return root.querySelector(sel); }
  var teaser = d.getElementById('fyb-teaser');
  var panel = $('.fyb-panel');
  var steps = {
    ask: $('[data-fyb-step="ask"]'),
    duedate: $('[data-fyb-step="duedate"]'),
    success: $('[data-fyb-step="success"]')
  };
  var emailInput = $('#fyb-email');
  var emailErr = $('#fyb-email-err');
  var hp = $('#fyb-hp');
  var dateInput = $('#fyb-date');
  var dateErr = $('#fyb-date-err');
  var payoff = $('#fyb-payoff');
  var wkLine = $('#fyb-wkline');
  var fruitEl = $('#fyb-fruit');
  var fruitName = $('#fyb-fruitname');
  var countLine = $('#fyb-count');
  var dateCta = $('#fyb-date-cta');
  var codeEl = $('#fyb-code');
  var copyBtn = $('#fyb-copy');
  var shopCta = $('#fyb-shop');

  if (subscribed && teaser) teaser.remove();
  if (subscribed) { var navs = d.querySelectorAll('[data-fyb-nav]'); for (var ni = 0; ni < navs.length; ni++) navs[ni].setAttribute('hidden', ''); }

  /* ---------- open / close / steps ---------- */
  var current = null;
  var stepAnim = false, stepAnimT = null, stepSwapT = null;
  function swapStep(name) {
    for (var k in steps) if (steps[k]) steps[k].classList.toggle('fyb-on', k === name);
    current = name;
    if (panel) panel.scrollTop = 0;
  }
  function showStep(name) {
    var prev = current;
    if (reduced || !panel || !stepAnim || !prev || prev === name || !steps[prev]) { swapStep(name); return; }
    /* outgoing step fades out, then the incoming step slides in while the panel height eases */
    clearTimeout(stepSwapT);
    var h0 = panel.offsetHeight;
    steps[prev].classList.add('fyb-leaving');
    stepSwapT = setTimeout(function () {
      steps[prev].classList.remove('fyb-leaving');
      swapStep(name);
      var h1 = panel.offsetHeight;
      if (h0 && h1 && h0 !== h1) {
        panel.style.transition = 'none';
        panel.style.height = h0 + 'px';
        panel.style.overflow = 'hidden';
        void panel.offsetHeight;
        panel.style.transition = 'height 340ms cubic-bezier(.23,1,.32,1)';
        panel.style.height = h1 + 'px';
        setTimeout(function () { panel.style.transition = ''; panel.style.height = ''; panel.style.overflow = ''; }, 360);
      }
    }, 150);
  }
  function openAt(name, source) {
    if (subscribed && !/^ddc_/.test(source || '')) return; /* the due-date calculator's buttons may reopen it for subscribers */
    clearTimeout(hideT);
    root.classList.remove('fyb-closing');
    root.removeAttribute('hidden');
    void root.offsetHeight; /* reflow so the open transition runs */
    root.classList.add('fyb-open');
    stepAnim = false; clearTimeout(stepAnimT); stepAnimT = setTimeout(function () { stepAnim = true; }, 420);
    showStep(name);
    if (teaser) teaser.classList.remove('fyb-in');
    track('fyb_open', { fyb_step: name, fyb_source: source || 'other' });
    if (name === 'ask' && w.BABYGO_ID && emailInput) { /* email known from elsewhere on the site → pre-filled with a tick, screen unchanged */
      if (w.BABYGO_ID.decorate(emailInput, { onChange: function () { fillStart = 0; } })) fillStart = Date.now() - 60000;
    }
    var input = name === 'ask' ? emailInput : (name === 'duedate' ? dateInput : null);
    if (input && !reduced && input !== dateInput) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 380);
  }
  var hideT = null;
  function close(via) {
    if (!root.classList.contains('fyb-open')) return;
    track('fyb_close', { fyb_step: current, fyb_via: via || 'other' });
    stepAnim = false;
    root.classList.add('fyb-closing');
    root.classList.remove('fyb-open');
    /* once the fade is done, actually hide the root: an opacity-0 panel still sits over the page otherwise */
    clearTimeout(hideT);
    hideT = setTimeout(function () {
      if (!root.classList.contains('fyb-open')) { root.setAttribute('hidden', ''); root.classList.remove('fyb-closing'); }
    }, reduced ? 30 : 380);
    if (teaser && !subscribed) setTimeout(function () { teaser.classList.add('fyb-in'); }, reduced ? 0 : 200);
  }
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-fyb-close]');
    if (c) close(c.classList.contains('fyb-decline') ? 'decline' : 'x');
    if (e.target === $('.fyb-scrim')) close('scrim');
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('fyb-open')) close('escape'); });
  /* Enter submits the current step (there is no <form>, so it would otherwise do nothing) */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.id === 'fyb-email') { e.preventDefault(); var b1 = $('#fyb-ask-cta'); if (b1) b1.click(); }
    else if (t && t.id === 'fyb-date') { e.preventDefault(); var b2 = $('#fyb-date-cta'); if (b2) b2.click(); }
  });

  /* Any trigger anywhere: data-fyb-open="ask|duedate" */
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fyb-open]');
    if (!t) return;
    e.preventDefault();
    var step = t.getAttribute('data-fyb-open') || 'ask';
    if (step === 'ask' && getEmail()) step = 'duedate'; /* resume where she left off */
    var source = t.getAttribute('data-fyb-source') || (t.id === 'fyb-teaser' ? 'teaser' : 'other');
    if (t.closest('#mobile-menu')) { /* opened from the mobile drawer: close it via the theme's own toggle */
      source = 'nav_mobile';
      var tog = d.querySelector('.mobile-toggle-wrapper.active .mobile-toggle');
      if (tog) tog.click();
    }
    openAt(step, source);
  });

  /* ?fyb=open */
  try {
    if (/[?&]fyb=open/.test(location.search)) {
      setTimeout(function () { openAt(getEmail() ? 'duedate' : 'ask', 'url'); }, 600);
    }
  } catch (e) {}

  /* ---------- teaser entry ---------- */
  var teaserSrcEl = teaser && teaser.querySelector('[data-fyb-source]');
  var teaserSrc = (teaserSrcEl && teaserSrcEl.getAttribute('data-fyb-source')) || 'teaser';
  try { sessionStorage.removeItem('fyb_teaser_hide'); } catch (e) {}
  if (teaser && !subscribed) {
    var shown = false;
    function reveal() {
      if (shown) return; shown = true;
      teaser.classList.add('fyb-in');
      track('fyb_teaser_shown', { fyb_source: teaserSrc });
    }
    setTimeout(reveal, 800);
    w.addEventListener('scroll', reveal, { once: true, passive: true });
  }
  /* dismiss X: close for this page view only — nothing stored, a refresh brings the
     teaser back (the X sits outside the [data-fyb-open] button, so no open fires) */
  d.addEventListener('click', function (e) {
    var x = e.target.closest('[data-fyb-dismiss]');
    if (!x) return;
    e.preventDefault();
    if (teaser) { teaser.remove(); teaser = null; }
    track('fyb_teaser_dismissed', { fyb_source: teaserSrc });
  });

  /* ---------- step 1: the ask ---------- */
  var fillStart = 0, emailStarted = false;
  if (emailInput) {
    emailInput.addEventListener('focus', function () { if (!fillStart) fillStart = Date.now(); }, { once: true });
    emailInput.addEventListener('input', function () {
      if (!fillStart) fillStart = Date.now();
      if (!emailStarted) { emailStarted = true; track('fyb_email_start'); }
      emailInput.classList.remove('fyb-err'); emailErr.classList.remove('fyb-on');
    });
  }
  var askCta = $('#fyb-ask-cta');
  if (askCta) askCta.addEventListener('click', function () {
    var email = (emailInput.value || '').trim();
    var dbg = /[?&]fyb=debug/.test(location.search);
    if (hp && hp.value) { /* honeypot filled: browser autofill does this to real people, so log it and carry on */
      if (dbg) console.warn('[fyb] honeypot had a value (ignored):', hp.value);
      hp.value = '';
    }
    if (!rx.test(email)) {
      if (dbg) console.warn('[fyb] email failed validation:', email);
      track('fyb_email_error', { fyb_reason: email ? 'invalid' : 'empty' });
      emailInput.classList.add('fyb-err'); emailErr.classList.add('fyb-on');
      emailInput.focus(); return;
    }
    var fillWait = CFG.minFillMs - (Date.now() - fillStart);
    if (fillWait > 0) { /* bot timing: slow the submit down rather than drop it */
      if (dbg) console.warn('[fyb] deferring submit by', fillWait, 'ms');
      askCta.disabled = true;
      setTimeout(function () { askCta.disabled = false; askCta.click(); }, fillWait);
      return;
    }
    setEmail(email);
    if (w.BABYGO_ID) w.BABYGO_ID.set(email, 'fyb');
    /* client/subscriptions requires a list relationship; without a configured
       general list, create/update the profile instead (consent is then granted
       at step 2 via the FYB list, or once the general list ID is configured). */
    if (CFG.generalList) {
      sendWithRetryQueue('subscriptions', subscriptionPayload(email, CFG.generalList, { signup_source: 'follow_your_bump' }));
    } else {
      sendWithRetryQueue('profiles', profilePayload(email, { signup_source: 'follow_your_bump' }));
    }
    track('fyb_email_submitted');
    requestMint(email); /* start minting early so success has the code */
    showStep('duedate');
  });

  /* ---------- step 2: due date ---------- */
  var DAY = 86400000;
  function computeWeek(dateVal) {
    if (!dateVal) return null;
    var due = new Date(dateVal + 'T00:00:00');
    if (isNaN(due.getTime())) return null;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var days = Math.round((due - today) / DAY);
    if (days < -14 || days > 280) return null; /* a due date is at most 40 weeks away */
    var week = Math.min(42, Math.max(4, 40 - Math.floor(days / 7)));
    return { week: week, weeksLeft: Math.max(0, Math.ceil(days / 7)), iso: dateVal };
  }
  function trimester(wk) { return wk <= 13 ? 'T1' : (wk <= 27 ? 'T2' : 'T3'); }
  var dateSelected = false;
  function renderPayoff(info) {
    if (!dateSelected) { dateSelected = true; track('fyb_duedate_selected', { fyb_week: info.week }); }
    var cardWeek = Math.min(40, info.week);
    var f = FRUIT[cardWeek] || FRUIT[40];
    wkLine.innerHTML = 'WEEK ' + info.week + ' <span>&middot; YOU ARE HERE &middot; ' + trimester(info.week) + '</span>';
    fruitEl.textContent = f[0];
    fruitName.textContent = f[1];
    countLine.innerHTML = info.weeksLeft > 1
      ? '<b>' + info.weeksLeft + ' Mondays</b> between now and meeting them.'
      : '<b>Any day now.</b> We’ll be with you either way.';
    dateCta.textContent = 'Start at week ' + info.week;
    if (payoff.classList.contains('fyb-on')) {
      /* already revealed: just re-pop the fruit for the new week */
      fruitEl.classList.remove('fyb-pop'); void fruitEl.offsetWidth; fruitEl.classList.add('fyb-pop');
    } else {
      w.requestAnimationFrame(function () { payoff.classList.add('fyb-on'); });
    }
  }
  function clearPayoff() {
    payoff.classList.remove('fyb-on');
    dateCta.textContent = 'Start my weekly emails';
  }
  /* Touch devices: the native picker pre-fills today's date and fires input/change while it is
     still open, so hold the week-card reveal until the picker closes (the field blurs). */
  var coarse = !!(w.matchMedia && w.matchMedia('(hover: none) and (pointer: coarse)').matches);
  var datePicking = false;
  var DATE_ERR_DEFAULT = dateErr ? dateErr.innerHTML : '';
  function dateProblem(val) {
    if (!val) return DATE_ERR_DEFAULT;
    var due = new Date(val + 'T00:00:00'); if (isNaN(due.getTime())) return DATE_ERR_DEFAULT;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var days = Math.round((due - today) / DAY);
    if (days > 280) return 'That is more than 9 months away, so it cannot be your due date yet.';
    if (days < -14) return 'That date has already passed. Double-check your due date.';
    return DATE_ERR_DEFAULT;
  }
  function dateReason(val) {
    if (!val) return 'empty';
    var due = new Date(val + 'T00:00:00'); if (isNaN(due.getTime())) return 'invalid';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var days = Math.round((due - today) / DAY);
    return days > 280 ? 'too_far' : (days < -14 ? 'passed' : 'invalid');
  }
  function showDateError() {
    dateErr.innerHTML = dateProblem(dateInput.value);
    dateInput.classList.add('fyb-err'); dateErr.classList.add('fyb-on');
  }
  function applyDate() {
    var info = computeWeek(dateInput.value);
    if (info) { renderPayoff(info); return; }
    clearPayoff();
    if (dateInput.value) showDateError();
  }
  /* Desktop: the native calendar is a separate popup that takes focus off the page and updates
     the field live while open. Wait until the page has focus again (picker closed) to reveal. */
  var settleT = null;
  function settleWhenPickerCloses() {
    if (settleT) return;
    settleT = setInterval(function () {
      if (!d.hasFocus()) return;
      clearInterval(settleT); settleT = null;
      applyDate();
      try { dateInput.blur(); } catch (e) {}
    }, 150);
  }
  function onDateChange() {
    dateInput.classList.remove('fyb-err'); dateErr.classList.remove('fyb-on');
    if (coarse && datePicking) return;
    if (!coarse && !d.hasFocus()) { settleWhenPickerCloses(); return; }
    applyDate();
  }
  function openPicker() {
    try { if (typeof dateInput.showPicker === 'function') { dateInput.showPicker(); return; } } catch (e) {}
    dateInput.focus();
  }
  function isoOffset(days) {
    var t = new Date(); t.setHours(0, 0, 0, 0); t.setDate(t.getDate() + days);
    return t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2);
  }
  if (dateInput) {
    dateInput.min = isoOffset(-14); dateInput.max = isoOffset(280);
    dateInput.addEventListener('input', onDateChange);
    dateInput.addEventListener('change', onDateChange);
    dateInput.addEventListener('focus', function () { datePicking = true; });
    dateInput.addEventListener('blur', function () { datePicking = false; if (coarse) onDateChange(); });
    if (!coarse) {
      /* desktop: the calendar is the only way in - click anywhere opens it, typing is blocked */
      dateInput.addEventListener('click', function (e) { e.preventDefault(); openPicker(); });
      dateInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter') return;
        e.preventDefault();
        if (e.key === ' ' || e.key === 'ArrowDown') openPicker();
      });
    }
  }
  var dateWrap = $('.fyb-datewrap');
  function syncDateEmpty() { if (dateWrap && dateInput) dateWrap.classList.toggle('fyb-empty', !dateInput.value); }
  if (dateInput) { ['input', 'change', 'focus', 'blur'].forEach(function (ev) { dateInput.addEventListener(ev, syncDateEmpty); }); syncDateEmpty(); }
  var calBtn = $('#fyb-calbtn');
  if (calBtn && dateInput) calBtn.addEventListener('click', function () {
    if (coarse) { dateInput.focus(); return; } /* focus opens the picker on touch and gives us a reliable blur */
    openPicker();
  });
  if (dateCta) dateCta.addEventListener('click', function () {
    var info = computeWeek(dateInput.value);
    if (!info) { track('fyb_duedate_error', { fyb_reason: dateReason(dateInput.value) }); showDateError(); if (!coarse) dateInput.focus(); return; }
    var email = getEmail();
    if (!email) { openAt('ask', 'other'); return; } /* safety: no email banked */
    if (CFG.fybList) {
      sendWithRetryQueue('subscriptions', subscriptionPayload(email, CFG.fybList, { due_date: info.iso, signup_source: 'follow_your_bump' }));
    } else {
      sendWithRetryQueue('profiles', profilePayload(email, { due_date: info.iso, signup_source: 'follow_your_bump' }));
    }
    track('fyb_duedate_submitted', { fyb_week: info.week });
    finishSuccess(info);
  });

  /* ---------- code minting (optional serverless endpoint) ---------- */
  var mintPromise = null;
  function requestMint(email) {
    if (!CFG.mintEndpoint) { mintPromise = Promise.resolve(null); return; }
    var ctl = ('AbortController' in w) ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 4000);
    mintPromise = fetch(CFG.mintEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.code) ? String(j.code) : null; })
      .catch(function () { return null; });
  }
  var codeType = 'fallback';
  function applyCode(code) {
    codeEl.textContent = code;
    shopCta.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CFG.redirect));
  }

  /* ---------- step 3: success ---------- */
  function finishSuccess(info) {
    applyCode(CFG.fallbackCode);
    (mintPromise || Promise.resolve(null)).then(function (code) {
      if (code) {
        codeType = 'unique';
        applyCode(code);
        var email = getEmail();
        if (email) sendWithRetryQueue('profiles', profilePayload(email, { bump_code: code }));
      }
      track('fyb_code_shown', { fyb_code_type: codeType });
    });
    showStep('success');
    setState({ status: 'subscribed', ts: Date.now(), week: info ? info.week : null });
    subscribed = true;
    if (teaser) teaser.remove();
    var doneNavs = d.querySelectorAll('[data-fyb-nav]'); for (var di = 0; di < doneNavs.length; di++) doneNavs[di].setAttribute('hidden', ''); /* hide the drawer button now, not just on the next page */
    track('fyb_signup_success', { fyb_week: info ? info.week : null });
    try { if (w.oaiq) w.oaiq('measure', 'registration_completed', { type: 'customer_action', amount: 0, currency: 'GBP' }); } catch (e) {} /* OpenAI ads pixel */
  }
  if (shopCta) shopCta.addEventListener('click', function () { track('fyb_shop_click', { fyb_code_type: codeType }); });
  if (copyBtn) copyBtn.addEventListener('click', function () {
    track('fyb_code_copied', { fyb_code_type: codeType });
    try { navigator.clipboard && navigator.clipboard.writeText(codeEl.textContent); } catch (e) {}
    copyBtn.textContent = 'Copied ✓';
    copyBtn.classList.add('fyb-done');
    setTimeout(function () { copyBtn.textContent = 'Copy'; copyBtn.classList.remove('fyb-done'); }, 2200);
  });

  queueFlush();
  w.FYB = { open: function (o) { openAt((o && o.step) || 'ask', (o && o.source) || 'api'); } };
})(window, document);
